import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import clsx from "clsx";
import AppResumoAlteracoes from "@/components/avulsos/appResumoAlteracoes/AppResumoAlteracoes";
import type { SecaoResumo } from "@/components/avulsos/appResumoAlteracoes/appResumoAlteracoes.types";
import type { AlteracaoRecursoVM, ResumoAlteracoes } from "./restricoes.utils";

function BadgeAlteracao({ recurso }: { readonly recurso: AlteracaoRecursoVM }) {
	return (
		<div className="flex items-center justify-between gap-3 rounded-lg px-2 py-1.5 hover:bg-muted/50">
			<span className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">{recurso.descricao}</span>
			<span
				className={clsx(
					"flex shrink-0 items-center gap-1 rounded-full px-2 text-xs font-bold",
					recurso.para ? "bg-success/15 text-success" : "bg-muted text-muted-foreground",
				)}
			>
				<FuseSvgIcon size={14}>{recurso.para ? "lucide:check" : "lucide:x"}</FuseSvgIcon>
				{recurso.para ? "Ativado" : "Desativado"}
			</span>
		</div>
	);
}

function ResumoContagem({ ativados, desativados }: { readonly ativados: number; readonly desativados: number }) {
	return (
		<div className="flex shrink-0 flex-wrap items-center gap-2 px-4 pb-3 pt-2">
			{ativados > 0 ? (
				<span className="flex items-center gap-1.5 rounded-full bg-success/15 px-2.5 py-1 text-xs font-bold text-success">
					<FuseSvgIcon size={16}>lucide:check</FuseSvgIcon>
					{ativados === 1 ? "1 ativada" : `${ativados} ativadas`}
				</span>
			) : null}
			{desativados > 0 ? (
				<span className="flex items-center gap-1.5 rounded-full bg-muted px-2.5 py-1 text-xs font-bold text-muted-foreground">
					<FuseSvgIcon size={13}>lucide:x</FuseSvgIcon>
					{desativados === 1 ? "1 desativada" : `${desativados} desativadas`}
				</span>
			) : null}
		</div>
	);
}

export default function ResumoAlteracoesPainel({ resumo }: Readonly<{ readonly resumo: ResumoAlteracoes }>) {
	const secoes: SecaoResumo[] = resumo.grupos.map((modulo) => ({
		id: modulo.id,
		titulo: modulo.descricao,
		tipo: "personalizada",
		conteudo: (
			<div className="flex flex-col gap-2">
				{modulo.telas.map((tela) => (
					<div key={tela.id} className="flex flex-col">
						<span className="px-1 text-sm font-bold text-muted-foreground">{tela.descricao}</span>
						{tela.recursos.map((recurso) => (
							<BadgeAlteracao key={recurso.id} recurso={recurso} />
						))}
					</div>
				))}
			</div>
		),
	}));
	return (
		<AppResumoAlteracoes
			secoes={secoes}
			contagem={<ResumoContagem ativados={resumo.ativados} desativados={resumo.desativados} />}
		/>
	);
}
